exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popupMenu{z-index:99}.takipiPopupMenu[vertical=top]{bottom:37px}.takipiPopupMenu[vertical=bottom]{top:37px}.takipiPopupMenu{z-index:2500;min-width:150px;max-width:320px;right:calc(204px - 100%)}.takipiPopupMenuArrow{right:12px;border-bottom-color:#e6ebf2}.takipiPopupMenu.itemGroups{max-width:116px}", ""]);

// exports
